import ProductItem from '../components/product/ProductItem';
import { getTranslation } from '../helpers';
import { initCarousel } from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

const selectors = {
  productItem: '[data-product-item]',
  relatedProducts: '[data-related-products]',
  complementaryProducts: '[data-complementary-products]',
};

const carouselOptions = {
  pagination: false,
  perPage: 1,
  drag: true,
  padding: { right: '40%' },
  breakpoints: {
    [unitlessBreakpoints.md]: {
      perPage: 3,
      padding: { right: '5%' },
    },
    [unitlessBreakpoints.lg]: {
      perPage: 3,
      padding: { right: 0 },
    },
    [unitlessBreakpoints.xl]: {
      perPage: 4,
      gap: '1.5rem',
      padding: { right: 0 },
    },
  },
};

export default class DynamicProductFeed {
  constructor(section) {
    this.el = section.el;
    this.section = section;
    this.productId = section.data.productId;
    this.limit = section.data.limit || 8;

    // Init product items
    const productItems = this.el.querySelectorAll(selectors.productItem);
    [...productItems].forEach(productItem => {
      new ProductItem(productItem);
    });

    initCarousel(this.el, carouselOptions);
    this.addRecommendedProducts();
    this.addComplementaryProducts();
  }

  renderEmptyMessage(message) {
    return `<h3 class="py-24 type-heading-4 text-center">${message}</h3>`;
  }

  addRecommendedProducts() {
    const collectionContentContainer = this.el.querySelector(
      selectors.relatedProducts,
    );

    // If doesnt have data-product-id or related-products attr on container do nothing
    if (!collectionContentContainer) {
      return;
    }
    this.recommendationsFetch(selectors.relatedProducts);
  }

  addComplementaryProducts() {
    const collectionContentContainer = this.el.querySelector(
      selectors.complementaryProducts,
    );
    // If doesnt have data-product-id or related-products attr on container do nothing
    if (!collectionContentContainer) {
      return;
    }

    this.recommendationsFetch(
      selectors.complementaryProducts,
      '&intent=complementary',
    );
  }

  recommendationsFetch(selector, additionalQuery = '') {
    const container = this.el.querySelector(selector);
    const url = `${theme.routes.recommendations}?section_id=${this.section.id}&limit=${this.limit}&product_id=${this.productId}${additionalQuery}`;
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;

        const recommendations = html.querySelector(selector);

        // If there are no splide slides for complementary products, display error
        // TODO: update to static string message.
        // add to json schema
        if (
          !recommendations.querySelector('.splide__slide') &&
          additionalQuery
        ) {
          container.innerHTML = this.renderEmptyMessage(
            getTranslation('product_feed.no_complementary_products'),
          );
          return;
        }

        if (recommendations && recommendations.innerHTML.trim().length) {
          container.innerHTML = recommendations.innerHTML;
          initCarousel(this.el, carouselOptions);
          const products = container.querySelectorAll(selectors.productItem);
          [...products].forEach(product => new ProductItem(product));
        }
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.error(e);
      });
  }
}
